import Vue from 'vue';
import App from './App.vue';
import router from './router/index'; // 引入路由
import Vant from 'vant'; // 引入 Vant 组件库
import 'vant/lib/index.css'; // 引入 Vant 样式
import axios from 'axios';
Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

// 使用 Vant 组件库
Vue.use(Vant);

// 创建 Vue 实例，并传入 router 选项
new Vue({
  router, // 注册路由
  render: h => h(App),
}).$mount('#app');